import React from "react";
import BackToHomeHeader from "../components/common/BackToHomeHeader";
import { CheckoutIntroSection, CheckoutMainContent } from "../components/pages/checkout/CheckoutPageSections";
import { NextProjectFooter } from "../components/common/Footer";

const CheckoutPage = () => {
	return [
		<BackToHomeHeader key="header" title="Job Posting Checkout" company="LinkedIn" />,
		<CheckoutIntroSection key="introSection" />,
		<CheckoutMainContent key="mainContent" />,
		<NextProjectFooter key="homeFooter" href="/how-you-rank" />,
	];
};

export default CheckoutPage;



// WEBPACK FOOTER //
// ./src/pages/checkout.js